import React from "react";

const Black = (props) => {
  const { children } = props;
  return <span className="black">{children}</span>;
};

export default Black;
